import { useEffect, useRef, useState } from "react";
import "../../css/element/TeacherSelector.css"
import TeacherConstant from "../../utils/constants/TeacherConstant";
import LocationCode from "../../utils/constants/LocationCode";

/**
 * props.short: true일때 symbol + name만 출력, false일때 symbol + name + location 출력
 * props.currentTeacher: 현재 선생님
 * props.containsAll: 전체 선택자 포함 여부
 * props.data: data에 포함돼있는 선생님 목록 전체.
 * props.location: location code. 전체를 원할 경우 LocationCode.ALL
 * props.onTeacherChange: teacher change method
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
let TeacherSelector = (props) => {
    let [isOpen, setIsOpen] = useState(false);

    let dropdownMenu = useRef();
    let selector = useRef();

    useEffect(() => {
        if (dropdownMenu && selector) {
            if (!props.short) {
                if (isOpen)
                    dropdownMenu.current.style.width = "200px"
                selector.current.style.width = "200px"
            }
        }
    }, [isOpen, props.short])


    let getTeacherLongName = (teacherid) => {
        let teacher = props.data.teachers[teacherid]
        let symbolName = getTeacherSymbolName(teacherid)
        let location = LocationCode.text[teacher.location]
        return symbolName + " (" + location + ")"
    }
    let getTeacherSymbolName = (teacherid) => {
        let teacher = props.data.teachers[teacherid]
        let major_symbol = TeacherConstant.major_symbol[teacher.major];
        let name = teacher.name;
        return major_symbol + name;
    }
    let getTeacherName = (teacherid) => {
        return teacherid === TeacherConstant.ID_SELECT_ALL ? "전체" :
            (props.short ? getTeacherSymbolName(teacherid)
                : getTeacherLongName(teacherid));

    }

    let getDefaultTeacherName = () => {
        let currentTeacherid = props.currentTeacher
        
        let teachers = props.data.teachers;
        if (props.currentTeacher !== TeacherConstant.ID_SELECT_ALL &&
            teachers[props.currentTeacher].major === TeacherConstant.major.MANAGER) {
            let teachers = props.data.teachers;

            for (let teacherid in teachers) {
                let teacher = teachers[teacherid]
                if ((props.location === LocationCode.ALL || props.location === teacher.location) && !teacher.leaved
                    && teacher.major !== TeacherConstant.major.MANAGER) {
                    currentTeacherid = teacherid
                    break;
                }
            }
        }
        return getTeacherName(currentTeacherid)
    }

    let getTeacherList = () => {
        let teachers = props.data.teachers;
        let ret = []
        for (let teacherid in teachers) {
            let teacher = teachers[teacherid]
            let teacherName = getTeacherName(teacherid)
            if ((props.location === LocationCode.ALL || props.location === teacher.location) && !teacher.leaved
                && teacher.major !== TeacherConstant.major.MANAGER) {
                //location이 전체 지점으로 지정된 경우나, 선생님의 location이 현재 지점과 같고 퇴사하지 않은 경우.
                ret.push(<div className="dropdown-menu" key={teacherName}
                    onClick={_ => props.onTeacherChange(parseInt(teacherid))}>
                    <p className="teacher-name">{teacherName}</p>
                </div>)
            }
        }
        if (props.containsAll) {
            ret.push(<div className="dropdown-menu" key={"전체"} onClick={(_) => {
                props.onTeacherChange(TeacherConstant.ID_SELECT_ALL);
            }}>
                <p className="teacher-name">전체</p>
            </div>)
        }
        return ret;
    }
    return (
        <div className={"teacher-selector"} onClick={_ => setIsOpen(!isOpen)} ref={selector}>
            <p className={"teacher-selector-text"}>
                {getDefaultTeacherName()}
            </p>
            <div className="teacher-selector-button">
            </div>
            {isOpen ? <div className="teacher-selector-dropdown" ref={dropdownMenu}>
                {getTeacherList()}
            </div> : null}
        </div>
    )
}
export default TeacherSelector;